import { render, staticRenderFns } from "./DataFields.vue?vue&type=template&id=77e451e0"
import script from "./DataFields.vue?vue&type=script&lang=js"
export * from "./DataFields.vue?vue&type=script&lang=js"
import style0 from "./DataFields.vue?vue&type=style&index=0&id=77e451e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports